import PropTypes from 'prop-types';
import React from 'react';
import Question from './Question';

const QuestionsList = ({
  questions, answers, answerQuestion, firstUnansweredQuestionId,
}) => {
  return (
    <div className="mt-4 mb-4">
      {questions.map(id => (
        <Question
          key={id}
          onAnswer={answer => answerQuestion(id, answer)}
          questionId={id}
          answer={answers[id]}
          scrollToQuestion={id === firstUnansweredQuestionId}
        />
      ))}
    </div>
  );
};

QuestionsList.propTypes = {
  questions: PropTypes.arrayOf(PropTypes.number).isRequired,
  answers: PropTypes.object.isRequired,
  answerQuestion: PropTypes.func.isRequired,
  firstUnansweredQuestionId: PropTypes.number,
};

export default QuestionsList;
